import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ButtonSkeleton = ({ width = 100, height = 40 }) => (
  <Skeleton width={width} height={height} borderRadius={5} />
);

export default ButtonSkeleton;
